export enum RoomOutlineProblem {
  SELF_INTERSECTS = "SELF_INTERSECTS",
  AREA_TOO_SMALL = "AREA_TOO_SMALL",
  CW_WINDING = "CW_WINDING",
  LIKELY_SELF_INTERSECTS = "LIKELY_SELF_INTERSECTS",
  DEGENERATED = "DEGENERATED",
}
